import classNames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

const RemoveSelectedDates = ({
  clearSelectedDates,
  tripType,
}: {
  clearSelectedDates: () => void;
  tripType?: string;
}) => {
  return (
    <button
      type="button"
      className={cx('clear')}
      role="tab"
      data-event-nlog="click"
      data-event-area-code={tripType ? 'cls.calendarclose' : 'cal.caldel'}
      onClick={clearSelectedDates}
    >
      날짜지우기
    </button>
  );
};

export default RemoveSelectedDates;
